import axiosInstance from '../api/axiosInstance';

const ENDPOINTS = {
  GET_TASK_LIST: '/TaskLists',
  GET_WASTEPOOL_LIST: '/WastePoolListYnt',
  DELETE_TASK_LIST: '/TaskListDelete',
  ADD_TASK: '/TaskListAdd',
  REMOVE_TASK: '/TaskListRemove',
}

export const getWastePoolList =  async (params = {}) => {
  const { basla } = params;
  var baslangic=basla=="undefined"?'2025-01-01':basla;
 
  let url = `${axiosInstance.defaults.baseURL}${ENDPOINTS.GET_WASTEPOOL_LIST}?basla=${baslangic}`;  
  return axiosInstance.get(url);
}
export const getTaskList = async (params = {}) => {
 
  var baslangic='2025-01-01';
  var bitis='2025-12-12';
  let url = `${axiosInstance.defaults.baseURL}${ENDPOINTS.GET_TASK_LIST}?baslangic=${baslangic}&bitis=${bitis}`;  
  return axiosInstance.get(url);
}

export const deleteTaskList = async (id) => {
  const url = `${axiosInstance.defaults.baseURL}${ENDPOINTS.DELETE_TASK_LIST}/${id}`;
  return axiosInstance.post(url);
}

export const addTask = async (params = {}) => {
  const { district, neighborhood, address, datetime,day } = params;
  const url = `${axiosInstance.defaults.baseURL}${ENDPOINTS.ADD_TASK}`;
  
  const formData = new FormData();
  formData.append('district', district);
  formData.append('neighbourhood', neighborhood);
  formData.append('address', address);
  formData.append('day', day);
  formData.append('datetime', "2025-01-01");
  
  return axiosInstance.post(url, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}
// Ekleme ile aynı filtrelerle (ilçe + mahalle + seçili sokaklar + gün) topluca siler.
export const removeTask = async (params = {}) => {
  const { district, neighborhood, address, day } = params;
  const url = `${axiosInstance.defaults.baseURL}${ENDPOINTS.REMOVE_TASK}`;

  const streets = Array.isArray(address) ? address.join(',') : address;

  const formData = new FormData();
  formData.append('district', district);
  formData.append('neighbourhood', neighborhood);
  formData.append('address', streets);
  formData.append('day', day);
  formData.append('datetime', "2025-01-01");

  return axiosInstance.post(url, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}
